import { ArmyListUnit, Nullable } from '@Models';
import {
  buildEntityActionState,
  EntityActionState,
} from '../EntityActionState';

export type ArmyListUnitState = EntityActionState<ArmyListUnit> & {
  name: Nullable<string>;
};

export const buildArmyListUnitState = (
  data: Partial<ArmyListUnitState> = {},
) => {
  return {
    ...buildEntityActionState<ArmyListUnit>(data),
    name: data.name || null,
  };
};

export enum ArmyListUnitActionState {
  Edit = 1,
  Delete = 2,
  Clone = 3,
  ShowV1 = 4,
  ShowV2 = 5,
  ShowV3 = 6,
  Favorite = 7,
}
